(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dw-home-brand-slider"] && !Shopify.designMode) return;
  try {
    function initBrandSliders(){
  document.querySelectorAll('.dw-home-brand-slider').forEach(slider=>{
    if(slider.dataset.dwBrandReady)return;
    slider.dataset.dwBrandReady='true';
    let paused=false;
    let resumeAt=0;
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    slider.addEventListener('pointerenter',()=>{paused=true});
    slider.addEventListener('pointerleave',()=>{paused=false;resumeAt=Date.now()+5000});
    slider.addEventListener('pointerdown',()=>{resumeAt=Date.now()+12000});
    slider.addEventListener('touchstart',()=>{resumeAt=Date.now()+12000},{passive:true});
    slider.addEventListener('wheel',()=>{resumeAt=Date.now()+12000},{passive:true});
    const timer=setInterval(()=>{
      if(!slider.isConnected){clearInterval(timer);return}
      if(reduced.matches||document.hidden||paused||slider.contains(document.activeElement)||Date.now()<resumeAt)return;
      const end=slider.scrollWidth-slider.clientWidth;
      if(end<=0)return;
      if(slider.scrollLeft>=end-4)slider.scrollTo({left:0,behavior:'smooth'});
      else slider.scrollBy({left:Math.min(220,slider.clientWidth*.65),behavior:'smooth'});
    },3500);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initBrandSliders);else initBrandSliders();
document.addEventListener('shopify:section:load',initBrandSliders);
  } catch(e) { console.error(e); }
})();

})();
